// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"f9d6267a","253":"f9d6267a","865":"8a92f50e"}[chunkId] + ".chunk.css";
};